<template>
    <div class="body-width" >
      <div class="div-row div-pad-top news-Medium-24" >
        VTS指挥演练系统
      </div>
      <div class="div-row">
        <p class="indentation">V.Dragon-VTS 5000 型指挥演练系统符合STCW公约马尼拉修正案及IMO A.857(20)决议对VTS操作人员进行岗前培训的要求。集实时数据接收处理、交通流仿真、信息显示于一体，可全面呈现交管中心实施交通管制时的可视化场景，具备海域监管、实时预警等功能，为VTS操作员提供实操演练环境。</p>
      </div>
      <div class="img_pad">
        <img src="../../../../assets/images/productcenter/hsyl/VTS/1.png">
      </div>
      <div align="left">
        <ul>
          <li><span>VTS操作员实操演练</span></li>
          <li><span>真实雷达、AIS及CCTV系统信号接入</span></li>
          <li><span>多源信息收集及发布</span></li>
          <li><span>海域实时监控，违规行为报警</span></li>
          <li><span>模拟交通管制区域交通流</span></li>
          <li><span>恶劣天气下的助航服务和突发状况下的应急演练</span></li>
        </ul>
      </div>
      <div class="img_pad1 img_left" align="left">
        <img style="padding-top:170px" src="../../../../assets/images/productcenter/hsyl/VTS/2.png">
        <img src="../../../../assets/images/productcenter/hsyl/VTS/3.png">
      </div>
    </div>
</template>

<script>
  export default {
    name: "VTSzhylxt"
  }
</script>

<style scoped>
  .div-pad-top {
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .img_pad{
    padding: 30px 0px 30px 0px;
  }
    .img_pad1{
    padding: 30px 0px 0px 0px;
  }
  .img_left{
    padding-left: 35px;
  }
  p{
    font-size: 16px;
    color: #666666;
  }
  li{
    color: #2E79BE;

  }
  li span{
    color: #666666;
  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/hsylxlcp/VTSzhylxt.vue